class AudioService {
    constructor() {
      this.audioContext = null;
      this.micStream = null;
      this.audioProcessor = null;
      this.audioLevel = 0;
      this.nextStartTime = 0;
    }

    getContext() {
      if (!this.audioContext || this.audioContext.state === 'closed') {
        // this.audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
        // this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        // Create audio context
        // this.audioContext = new AudioContext({ sampleRate: 16000 });
        this.audioContext = new AudioContext({
            sampleRate: 16000,
            latencyHint: 'interactive'
        })
        console.log('The AudioContext sample rate is:', this.audioContext.sampleRate, 'Hz');
      }
      return this.audioContext;
    }

    closeContext() {
      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
        this.micStream = null;
        this.audioProcessor = null;
	this.nextStartTime = 0;
      }
    }

    suspend() {
      if (this.audioContext) this.audioContext.suspend();
    }

    resume() {
      if (this.audioContext) this.audioContext.resume();
    }




  resetAll() {
    // Close AudioContext
    if (this.audioContext) {
      this.audioContext.close().catch(() => {});
      this.audioContext = null;
    }

    // Stop and release mic stream
    if (this.micStream) {
      this.micStream.getTracks().forEach(track => track.stop());
      this.micStream = null;
    }

    // Disconnect audio processor if exists
    if (this.audioProcessor) {
      this.audioProcessor.disconnect();
      this.audioProcessor = null;
    }

    // Reset state
    this.audioLevel = 0;
    this.nextStartTime = 0;
    console.log("Reseted all audio");
  }



  }

// singleton instance
export default new AudioService();
